// moment-timezone relies on `moment` already existing because it monkey-patches `moment.tz`
import moment from 'moment'
import 'moment-timezone'

// moment is the primary export, but generally you want the other util functions instead
export default moment

// uses moment-timezone to guess the current timezone for the user's browser
export const DEFAULT_TIMEZONE = guessTimezone()

/**
 * Convert an `hour` from the given `timezone` into the hour in UTC time.
 *
 * @param {Number} hour      The hour to convert.
 * @param {String} timezone  The name of the "local" timezone to convert from.
 * @return {Number}          The UTC hour.
 */
export function toUTC(hour, timezone) {
  return moment
    .tz(Date.now(), timezone)
    .hour(Number(hour))
    .utc()
    .hour()
}

/**
 * Convert an `hour` to the given `timezone`. (from UTC)
 *
 * @param {Number} hour      The UTC hour to convert.
 * @param {String} timezone  The name of the "local" timezone to convert to.
 * @return {Number}          The "local" hour.
 */
export function fromUTC(hour, timezone) {
  return moment
    .utc(Number(hour), 'H')
    .tz(timezone)
    .hour()
}

/**
 * Gets a list of available timezones.
 *
 * @return {Array}
 */
export function getTimezones() {
  return moment.tz.names()
}

function guessTimezone() {
  try {
    return moment.tz.guess()
  } catch (err) {
    return 'UTC'
  }
}
